import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import associateServices from "../../../../services";
import {toast} from "react-toastify";
import TipCurrencyDropdown from "./currency-dropdown";
import InstrumentIcon from "../../../../components/instrument-icon";
import Big from "big.js";
import store from "../../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../../actions/authentication-actions";
import InformationToast from "../../../../components/toast/InformationToast";

const UnifyBalanceContent = () => {
    const {
        currencyList,
        currencies,
        selectedWallet
    } = useSelector(state => state.authenticationReducer)

    const [step, setStep] = useState('calculate')
    const [calculation, setCalculation] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const {t} = useTranslation()
    const [selectedCurrency, setSelectedCurrency] = useState({})

    console.log('calculation = ', calculation)

    useEffect(() => {
        setCalculation({})
        setStep('calculate')
    }, [selectedCurrency?.code])
    const handleChangeWallet = wall => {
        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency(wall)
    }

    useEffect(() => {
        if (selectedWallet)
            handleChangeWallet(selectedWallet)
    }, [selectedWallet])


    const handleCalculate = () => {
        setSubmitting(true)
        associateServices.calculateUnifyBalances({
            currency: selectedCurrency?.code
        }).then(res => {
            setSubmitting(false)
            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))

            setCalculation(res?.data)
            setStep('unify')
        })
    }
    const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

    const handleUnifyBalances = () => {

        if (step === 'calculate')
            return handleCalculate()

        setSubmitting(true)
        // todo get curreny amount !!!
        associateServices.unifyBalances({
            currency: selectedCurrency?.code
        }).then(res => {
            setSubmitting(false)

            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))


            associateServices.getWallets({}).then(handleUserWallets)
            setStep('calculate')
            setCalculation({})


            toast(<InformationToast
                icon={'ti-info-circle'}
                title={t(`general.information`)}
                message={t(`unify-balances.you-have-unified-balances`)}
            />)

        })
    }


    return (


        <div className="modal__form">

            <div className="modal__drops">


                <TipCurrencyDropdown selectedCurrency={selectedCurrency}
                                     handleChangeWallet={handleChangeWallet}
                                     currencyList={currencyList}/>
            </div>

            <div className="modal__drops">

                <div className="w-100 row container flex-wrap justify-content-around pt-4">

                    {
                        calculation?.included_wallets?.map(currencyCode => (
                            <div key={currencyCode?.currency}
                                 className="d-flex align-items-center gap-1 col-auto">
                                  <span>
                                        <InstrumentIcon code={currencyCode?.currency}/>
                                  </span>

                                <div>
                                    <span className='small text-secondary'>{Big(currencyCode?.balance || 0).toFixed(currencyCode?.digit || 2)} </span>
                                    <br/>
                                    <span>{Big(currencyCode?.target || 0).toFixed(calculation?.digit || 2)} {calculation?.currency}</span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            {
                selectedCurrency?.code &&
                <div className="form__cellar text-secondary">
                    <span>
                        {
                            step === 'calculate' ? t('unify-balances.description', {code: selectedCurrency?.code})
                                :
                                calculation?.sum > 0 ? t('unify-balances.calculated', {
                                    code: calculation?.currency,
                                    balance: calculation?.sum
                                }) : t('unify-balances.not-wallet-found-to-unify')
                        }
                    </span>
                </div>
            }


            {
                step === 'calculate' || calculation?.sum > 0 ?
                    <FormButton
                        label={t(step === 'calculate' ? 'unify-balances.calculate' : 'unify-balances.unify')}
                        loading={submitting}
                        onClick={handleUnifyBalances}
                    /> : null
            }


        </div>
    )

}


export default UnifyBalanceContent
